import styled from "@emotion/styled";
import type { FC } from "react";

const StyledJsonContainer = styled.pre`
	margin: 0;
	padding: 16px;
	background-color: #1e1e1e;
	border-radius: 4px;
	overflow-x: auto;
	font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
	font-size: 13px;
	line-height: 1.6;
	color: #d4d4d4;

	.json-key {
		color: #9cdcfe;
	}

	.json-string {
		color: #ce9178;
	}

	.json-number {
		color: #b5cea8;
	}

	.json-boolean {
		color: #569cd6;
	}

	.json-null {
		color: #569cd6;
	}

	.json-punctuation {
		color: #d4d4d4;
	}
`;

interface JsonViewerProps {
	jsonString: string;
}

export const JsonViewer: FC<JsonViewerProps> = ({ jsonString }) => {
	const highlightJson = (json: string): string => {
		try {
			// Try to parse and format the JSON
			const parsed = JSON.parse(json);
			const formatted = JSON.stringify(parsed, null, 2);

			// Apply syntax highlighting
			return formatted
				.replace(/&/g, "&amp;")
				.replace(/</g, "&lt;")
				.replace(/>/g, "&gt;")
				.replace(/"([^"]+)":/g, '<span class="json-key">"$1"</span>:')
				.replace(/: "([^"]*)"/g, ': <span class="json-string">"$1"</span>')
				.replace(/: (-?\d+\.?\d*)/g, ': <span class="json-number">$1</span>')
				.replace(/: (true|false)/g, ': <span class="json-boolean">$1</span>')
				.replace(/: (null)/g, ': <span class="json-null">$1</span>');
		} catch (e) {
			// If parsing fails, return the original string
			return json;
		}
	};

	return (
		<StyledJsonContainer
			dangerouslySetInnerHTML={{ __html: highlightJson(jsonString) }}
		/>
	);
};
